// extracted by mini-css-extract-plugin
export default {"collapseButton":"Folders_collapseButton__FOgGk","svgIcon":"Folders_svgIcon__zEpcm","tabsHeight":"Folders_tabsHeight__kImOi","btstrapPrimaryBtn":"Folders_btstrapPrimaryBtn__mFPan"};